import { FilterSizeVariants, SizeCategory } from "../../types";
import { resolveAdvancedData, resolveSimpleData } from "../../utils";

export type SizeFilterMode =
  | FilterSizeVariants.SIMPLE
  | FilterSizeVariants.ADVANCED;

export const checkIfActive = (item, activeItem) => {
  if (Array.isArray(activeItem)) {
    return activeItem.some(active => active.key === item.key);
  } else {
    return item?.key === activeItem?.key;
  }
};

export const getAllSizes = filter => {
  const getDeepestChildren = group => {
    const children = group?.children;
    if (!Array.isArray(children) || children.length === 0) return [group];

    const hasNested = children.some(
      child => Array.isArray(child?.children) && child.children.length > 0
    );
    return hasNested
      ? children.flatMap(child => getDeepestChildren(child))
      : children;
  };

  const allSizes = (filter?.data || []).flatMap(sizeGroup =>
    getDeepestChildren(sizeGroup)
  );
  return allSizes;
};

export const collectLeafKeysForMode = (
  categories: SizeCategory[],
  mode: SizeFilterMode
): Set<string> => {
  const keys = new Set<string>();
  for (const cat of categories) {
    const groups =
      mode === FilterSizeVariants.SIMPLE
        ? resolveSimpleData(cat?.data) || []
        : resolveAdvancedData(cat?.data) || [];
    const leaves = getAllSizes({ data: groups });
    for (const leaf of leaves) {
      if (typeof (leaf as { key?: string })?.key === "string") {
        keys.add((leaf as { key: string }).key);
      }
    }
  }
  return keys;
};

export const getKey = (
  item: { key?: string; label?: string },
  fallback: string
) => item?.key || item?.label || fallback;

export const collectAllSizes = (categories: SizeCategory[]) => {
  if (!Array.isArray(categories)) return [];

  return categories.flatMap(category => {
    const advanced = resolveAdvancedData(category?.data);
    if (Array.isArray(advanced) && advanced.length) {
      return getAllSizes({ data: advanced });
    }

    const simple = resolveSimpleData(category?.data);
    if (Array.isArray(simple) && simple.length) {
      return getAllSizes({ data: simple });
    }

    return [];
  });
};
